import(/* webpackMode: "eager", webpackExports: ["Welcome"] */ "/vercel/path0/components/Welcome/Welcome.tsx");
